export default {
  EAT_SPINNER: 'spinner',
  EAT_COINS: 'coins',
  EAT_CELL: 'clover and bomb'
}
